module.exports = __webpack_public_path__ + "static/img/help_img_hover.b14ed12c.png";